import {isBelowBreakpoint} from "@/utils/Dom";
import EventBus from "@/utils/EventBus";

export async function guideClickOnElement(selector){
    await emulateClick(document.querySelector(selector));
}

// export async function guideDoubleClickOnElement(selector) {
//     await doubleClick(document.querySelector(selector));
// }

export async function guideClickOnElementInTopActivity(selector){
    return guideClickOnElement("[class*='activity-top'] " + selector);
}

export async function guideGetValue(selector) {
    let element = document.querySelector(selector);
    return element.value;
}

export async function clickOnGridRow(index){
    try {
        let selector = `//*[contains(@class, 'activity-top')]//*[@data-test-path='base-grid']//*[@data-row='${index}']//*[@data-col='0']`;

        for (let i = 0; i < 500; i++) {
            let element = evalXpath(selector);
            if (element && elementEnabled(element)) {
                emulateClick(element);
                return true;
            }
            await sleep(100);
        }

        let finalElement = document.evaluate(
            selector,
            document,
            null,
            XPathResult.FIRST_ORDERED_NODE_TYPE,
            null
        ).singleNodeValue;

        if (!finalElement) {
            throw new Error(`Element not found for XPath: ${selector}`);
        }

        emulateClick(finalElement);
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function scrollSelectorToBottom(selector, px = 10000) {
    for (let i = 0; i < 500; i++) {
        let element = evalXpath(selector);
        if (element && elementEnabled(element)) {
            element.scroll({top: px, behavior: 'instant'});
            return true;
        }
        await sleep(100);
    }
}

export async function clickOnTab(textInElement) {
    return clickOnText(textInElement, true, "//li[@role='presentation']")
}

async function waitForOneByXpath(xpath, timeout = 5000) {
    let startTime = Date.now();

    while (Date.now() - startTime < timeout) {
        let result = document.evaluate(
            xpath,
            document,
            null,
            XPathResult.FIRST_ORDERED_NODE_TYPE,
            null
        ).singleNodeValue;

        if (result) return result;

        await new Promise(resolve => setTimeout(resolve, 100));
    }

    throw new Error("Element not found within timeout: " + xpath);
}
export async function clickOnText(textInElement, inTopActivity = true, parentExpression = "", parentObject = "//*") {
    let selector;
    try {
        textInElement = textInElement.trim();
        let prefix = inTopActivity ? "//*[contains(@class, 'activity-top')]" : "";
        prefix += parentExpression;

        selector = `${prefix}${parentObject}[normalize-space(text())='${textInElement}']`;

        await waitForOneByXpath(selector);

        for (let i = 0; i < 500; i++) {
            let element = document.evaluate(
                selector,
                document,
                null,
                XPathResult.FIRST_ORDERED_NODE_TYPE,
                null
            ).singleNodeValue;

            if (element && elementEnabled(element)) {
                emulateClick(element);
                return true;
            }
            await sleep(100);
        }

        let finalElement = document.evaluate(
            selector,
            document,
            null,
            XPathResult.FIRST_ORDERED_NODE_TYPE,
            null
        ).singleNodeValue;

        if (!finalElement) {
            throw new Error(`Element not found for XPath: ${selector}`);
        }

        emulateClick(finalElement);
    } catch (e) {
        console.error(e);
        throw e;
    }
}

export async function guideWaitForValue(selector) {
    for(let i=0; i<40000; i++){
        if(await guideGetValue(selector) !== ""){
            return true;
        }
        await sleep(10);
    }

    throw new Error(`Element not found: ${selector}`);
}

export async function openMainMenu(){
    // todo upewniamy się, że menu jest otwarte na mobilnym jak i na desktopie
    let app = document.querySelector(".app-viewport");
    if(app.classList.contains("hide-left-menu")) {
        await guideClickOnElement("#desktop-left-menu-toggle-button");
    }
    else {
        if(isBelowBreakpoint("md")) {
            let mobileApp = document.querySelector("#left-menu-toggle-button")
            if (mobileApp.classList.contains("btn-plm-outline-primary")) {
                await guideClickOnElement("#left-menu-toggle-button");
            }
            // EventBus.$emit('openMainMenu');
        }
    }
}

export async function guideFillInput(selector, text){
    if(!selector.includes('input')){
        selector = selector + " input";
    }
    document.querySelector(selector).focus();

    await sleep(10);

    for(let i=0; i<=text.length; i++){
        document.querySelector(selector).value = text.substring(0, i);
        await sleep(10);
    }
    document.querySelector(selector).blur();
    document.querySelector('#desktop-left-menu-toggle-button').focus();
}

export async function guideSelectInput(selector, optionIndex = 0) {
    const selectElement = document.querySelector(selector);

    if (selectElement) {
        selectElement.selectedIndex = optionIndex;

        const event = new Event('change', { bubbles: true });
        selectElement.dispatchEvent(event);
    } else {
        throw new Error(`Element not found: ${selector}`);
    }
    selectElement.blur();
    document.querySelector('#desktop-left-menu-toggle-button').focus();
}



export async function guideWaitForElement(selector){
    for(let i=0; i<400; i++){
        if(document.querySelector(selector)){
            return true;
        }
        await sleep(10);
    }

    throw new Error(`Element not found: ${selector}`);
}

export async function guideWaitForElementByXPath(selector){
    for (let i = 0; i < 500; i++) {
        let element = evalXpath(selector);
        if (element && elementEnabled(element)) {
            return true;
        }

        await sleep(100);
    }

    throw new Error(`Element not found: ${selector}`);
}

export async function guideWaitForElementByXPathWithoutTime(selector) {
    while (true) {
        const element = evalXpath(selector);
        if (element && elementEnabled(element)) {
            return element;
        }
        await sleep(100);
    }
}


export async function guideWaitForElementLong(selector) {
    for(let i=0; i<30000; i++){
        if(document.querySelector(selector)){
            return true;
        }
        await sleep(10);
    }

    throw new Error(`Element not found: ${selector}`);
}